<template>
<div class="chapter">
<div class="inner_page">
<div class="frontmatter" title="Don’t Squat with Your Spurs On Vol. 2">
<div class="recto">
<h1><a id="d0e2">Don’t Squat with Your Spurs On Vol. 2</a></h1><a id="d0e2">
<h2>A Cowboy’s Guide to Life</h2>
<h3>Texas Bix Bender</h3>
<img alt="Gibbs Smith Logo" src="images/logo.jpg"/>
</a></div><a id="d0e2">
</a></div><a id="d0e2">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// recto.vue?c1ee3792